/**
 * Wire contract shared by both live-coaching clients — the focused view and the legacy voice-agent
 * panel. Both stream to the same BE assistant, so these strings must have exactly one definition:
 * if the assistant name drifts the two views silently route to different agents, and if the header
 * drifts the agent stops gating tactical suggestions against end-of-call summaries.
 *
 * Lives here rather than inside either view so neither module depends on the other.
 */

export const SALES_LIVE_COACHING_ASSISTANT_NAME = 'SalesLiveCoachingAssistant';

/**
 * Attached to each live-suggestion stream so the BE coach agent can tell a tactical in-the-moment
 * request from any other user content. The agent's starter prompt gates on the opening line, so
 * this has to lead the message — it does nothing buried in the body.
 */
export const LIVE_SUGGESTION_PROMPT_HEADER = `LIVE COACHING REQUEST

The call is in progress. Below are the latest transcript lines. Give me ONE short, tactical, in-the-moment coaching suggestion for what the rep should say or do next. Do NOT summarize the call.`;
